import styled from 'styled-components'

export const ContainerTeam = styled.div`
    background-color: var(--background-season-2);
    color: var(--text-body);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    width: 100vw;
    padding-top: 5rem;
    padding-bottom: 5rem;
    flex-direction: column;
    align-content: space-around;
    h2 {
        padding-bottom: 4rem;
        text-align: center;
        font-weight: 400;
        font-size: 32px;
        line-height: 55px;
    }
`

export const Groups = styled.div`
display: flex;
flex-direction: row;
flex-wrap: wrap;
    .inner-group {
        max-width: 95vw;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
    .inner-group div {
        padding-left: 2rem;
        margin-bottom: 1rem;
        img {
            margin-bottom: 1rem;
        }
        p {
            text-align: center;
        }
        p + p {
            font-weight: 800;
        }
    }

    @media(max-width: 425px) {
        .inner-group div {
            padding-left: 1rem;
        }
    }

    @media(max-width: 375px) {
        .inner-group div {
            padding-left: 0;
        }
    }

`